














































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BFormSelect,
  BAlert,
  BButton,
  BSpinner
} from 'bootstrap-vue'
import { PaginatedList } from '@/api/models/common/paginatedList'
import moment from 'moment'
import { PtfBeneficiaireBeneficiaire } from '@/api/models/ptfBeneficiaire/Beneficiaire'
import CreateBeneficiaire from './Create.vue'
import EditBeneficiaire from './Edit.vue'

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BAlert,
    CreateBeneficiaire,
    BButton,
    BSpinner,
    EditBeneficiaire
  }
})
export default class BeneficiairesList extends Vue {
  paginatedListBeneficiaires: PaginatedList<PtfBeneficiaireBeneficiaire> = new PaginatedList()
  searchQuery = ''
  currentPage = 1
  perPage = 10
  perPageOptions = [5, 10, 25, 50, 100]
  timeout: any = null;
  isAddNewBeneficiaireSidebarActive = false;
  isUpdateBeneficiaireSidebarActive = false;
  selectedBeneficiaireId = "";
  isLoading = false;

  tableColumns = [
    { key: 'nom', label: 'Nom Prénom', sortable: false },
    { key: 'email', label: 'Email', sortable: false },
    { key: 'telephone', label: 'Téléphone', sortable: false },
    { key: "entrepriseLibelle", label: "Entreprise", sortable: false },
    { key: 'Actions', sortable: false }
  ]

  get totalRows() {
    return this.paginatedListBeneficiaires.totalCount || 0
  }

  get paginationFrom() {
    return (this.currentPage - 1) * this.perPage + 1
  }

  get paginationTo() {
    return Math.min(this.currentPage * this.perPage, this.totalRows)
  }

  async created() {
    await this.loadListBeneficiaires({
        pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
    })
  }

  editBeneficiaire(beneficiaireId: string) {
    console.log("Editing beneficiaire with ID:", beneficiaireId);
    this.selectedBeneficiaireId = beneficiaireId;
    this.isUpdateBeneficiaireSidebarActive = true;
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListBeneficiaires({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery
    });
  }

  @Watch('searchQuery')
//   @Watch("sortBy")
//   @Watch("isSortDirDesc")
  async searchAdherent() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListBeneficiaires({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        search: this.searchQuery,
      })
    }, 1000);
  }

  async loadListBeneficiaires(params: any) {
    this.isLoading = true;
    try {
      this.paginatedListBeneficiaires = await this.$http.ptfBeneficiaire
        .beneficiaires.listBeneficiaires(
            params?.pageNumber ?? 1,
            params?.pageSize ?? 10,
            // params?.orderBy,
            // params?.orderByDescending,
            params?.search ?? ""
        )
    } catch (error) {
      console.error('Erreur lors du chargement des bénéficiaires:', error)
    } finally {
      this.isLoading = false;
    }
  }

  formatDate(date: string) {
    return date ? moment(date).format('DD/MM/YYYY') : ''
  }

  formatPhoneNumber(phone: string) {
    if (!phone) return ''
    // Retirer tous les caractères non numériques
    const cleaned = phone.replace(/\D/g, '')
    // Formater par groupe de 2 chiffres
    return cleaned.match(/.{1,2}/g)?.join(' ') || cleaned
  }

  onRowSelected(record: any) {
    this.$router.push({ name: "manage-beneficiaires-meetings", params: { id: record.id } });
  }
}
